<template>
    <div class="col-lg-11 col-11 mx-auto">
        <div class="card card-widget widget-user">
            <div class="widget-user-header text-white"
            style="background: url('/assets/images/pexels-brett-sayles-3027216_balloons.png')  center;">
                <h2 class="widget-user-desc text-left">Cheer others on; Know that You can, too.</h2>
                <!-- <h2 class="widget-user-desc text-left">Even as the years go by.</h2> -->
                <h4 class="widget-user-desc text-right">Version 2.0 &amp; beyond </h4>
                <h4 class="widget-user-username text-right">Here we come</h4>
            </div>
            <div class="widget-user-image">
                <img class="img-circle" src="/assets/images/pexels-brett-sayles-3027216.jpg" alt="User Avatar">
            </div>
        </div>

        <div class="row d-flex justify-content-between">
                <h4 class="col-4" v-if="timeslicesdata.length<1">Community-shared Time-Slices will appear below</h4>
                <h4 class="col-4" v-if="timeslicesdata.length>0">Community-shared Time-Slices:</h4>
                <!-- <a @click="showVideoModal()" class="btn btn-sm col-2"><i class="fas fa-tv"></i> Info</a> -->
                <a @click="showTimeSliceSwitcher()" class="btn btn-sm col-2"><i class="fas fa-plus"></i> Share  a Time-Slice of You</a>
        </div>
        <div class="list-group-item">
                <div class="row">
                    <div v-for="aSlice in timeslicesdata"  :key="aSlice.id" class="col-auto col-md-4">
                        <div class="content-box-gray card" >
                        <div class="title text-center d-flex">
                            <span class="col-10"><small class="mt-1" style="margin:auto;" v-html="getSubset(aSlice.headline, 45)"></small><br/>
                            <small>(<em>{{aSlice.user.name}})</em>&nbsp;{{getDateFormat(aSlice.created_at)}}</small></span>
 <a @click="viewFull(aSlice.id)" title="Show" class="btn btn-sm col-2 text-right"><i class="fas fa-eye fai-white"></i></a>

                        </div>
                            <div class="content">
 <!-- <h2 class="widget-user-username text-left">{{aSlice.headline}}</h2> -->
                            <img v-if="aSlice.visual_option=='image'" class="float-left" style="width:50%;" :src="getFilePath(aSlice.image.file_path)"/>
                            <iframe  v-if="aSlice.visual_option=='video'" id="aSlice.id" :src="aSlice.videourl" width="50%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            <div class="card mx-1 p-0">
                                    <!-- <p>{{aSlice.headline}}
                                        <em> @({{aSlice.created_at}})</em>
                                    </p> -->
                                    <div class="row d-flex justify-content-between">
                                    <small class="m-2 px-2"  v-html="getSubset(aSlice.text, 80)"></small>
                                    </div>
                                    <div class="d-flex flex-row justify-content-end"></div>
                                <div class="card bg-secondary mb-1">
                                <!-- <table><tr><td  style="text-align:center;font-size:.8em;" colspan="3">TimeSlice Visibility:</td></tr>
<tr><td style="text-align:center;" v-for="item in visibilities" :key='item'>
                                       <label class="radiolabel" :for="item"> {{item}}<br/>
                                        <input type="radio" :id="item" v-model="aSlice.visibility" :value="item" >
                                       </label>
</td>
</tr></table> -->
                                </div>

                            </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';


export default {
    components: { Errors },
    name: "ShowofForumHome",
    data() {
        return {
        userdata:[],
        timeslicesdata:[],
        errors: {
                nahme: '',
                message: '',
                },
        visibilities: ['private', 'community', 'world'],
        }
    },
    props: {
        user:'',
        apikey:'',
        communitytimeslices:'',

    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.timeslicesdata = JSON.parse(this.communitytimeslices);

        EventBus.$on('refreshShowofforumHome', (data) => {
            this.refreshPage();
        });
    },

    methods: {
        getDateFormat(aDate) {
            return moment(aDate).format('DD MMM YY');
        },
        viewFull(timeSliceID) {
            // console.error(timeSliceID);
            var tS = '';
            [...this.timeslicesdata].map((aTS)=>{
                if(aTS.id == timeSliceID) tS = aTS;
            });
            // console.log(tS);
            EventBus.$emit('showFullTS', {timeslicedata:tS});

        },
        strip(html){
        let doc = new DOMParser().parseFromString(html, 'text/html');
         return doc.body.textContent || "";
        },
        getSubset(text, size) {
            var theInput = this.strip(text);
            return theInput.substring(0,  size) + '...';
        },
        showTimeSliceSwitcher() {
            console.log("invoking viz switcher...");
            var data = {userdata: this.userdata};
            EventBus.$emit('showofForumVisibilitySwitcher', (data));
        },
        getFormattedDate(utcString) {
            return new Date(Date.UTC(utcString));

        },
        deleteSlice(id) {
            this.swalConfirm(id);
        },
        doDeleteSlice(id) {
            console.error("Deleting " +id);
            axios.put(`/showofforum/timeslice/delete/`+id)
            .then(response => {
            if (!response.data.deleted) {
                console.error("Unable to delete. Please try later");
            } else {
               console.log(response);
               this.refreshPage();
            }
            })
            .catch(err => {
                console.error(err);
            });
        },
        getFilePath(filePath) {
            return "/storage/"+ filePath;
        },
        showForum(channel) {
            console.log("Show forum: " + channel);
            window.location.replace('/forum/channels/' + channel.name);
        },
        getIconAndName(channel) {
            return channel.icon + channel.name;

        },
        showCreateModal(){
            console.error('showCreateModal invoked...');
            const payload = {userdata: this.userdata};
            EventBus.$emit('displayShowOffCreateModal', payload);
        },
        showVideoModal(){
            const payload = {title:"Why Time-Slice, when we have 100's of other Social Media Posts?",
            videourl: 'https://player.vimeo.com/video/626019659?h=fb5c62f51f',
            displayText: this.videoText};
            EventBus.$emit('displayVideoModal', payload);
        },
        refreshPage(){
            window.location.reload();
        },
        swalConfirm(id) {
             Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // setTimeout( function (id) {
                    //     this.doDeleteSlice(id);
                    // }, 3000);
                    this.doDeleteSlice(id);
                    Swal.fire(
                        'Deletion in progress!',
                        '',
                        'success'
                    );
                }
            });
        },
    },
    computed:{
        videoText() {
            var retval =  "<div><small><p>Record a time-slice of yourself, about yourself, as you are today.</p><br/>";
            retval +=  "<p>But not just any time-slice.  This one is about <em>you</em>, ready to grow and evolve you to the next level,";
            retval +=  "<p>(whatever that may mean for <em>you</em>).</p> ";
            retval +=  "<p>These Time-Slice records will help you stay focussed, strive, and deliver a Better You, to you.</p>";
            retval +=  "<p>And you will be able to actually track your progress, Time-Slice by Time-Slice.";
            retval +=  "<p>(Instead of digging through all the confusion and crowding on social posts)";
            retval +=  "<br/><br/>This is your private journey, to the next Version of you.</p>";
            retval +=  "<p>(Maybe, one day you may want to show this to others, \"go public\" with your journey, your growth... who knows?)";
            retval +=  "<br/><br/>But for now, focus on, and enjoy, your private adventure and challenge. </p><p>Go ahead, now.  Create your Time-Slice.</p></small></div>";
            return retval;
        }
    }


}
</script>

<style scoped>

.radiolabel{
    /* display:inline-block; */
    font-size: .5em;
    font-weight: 400 !important;
}

.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:3px solid #fff;
    background: rgb(209, 219, 248);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:rgb(18, 7, 240);
}
.fai-orange{
    color:rgb(230, 111, 13);
}
.fai-white{
    color:rgb(255, 255, 255);
}


.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}

.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#5fa3ca;
    font-size:.75em;
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}







</style>
